type TokenSource = () => string | null;

export class TokenManager {
  private tokens: TokenSource[];

  constructor(tokens: TokenSource[] = []) {
    this.tokens = tokens;
  }

  getToken(): string | null {
    for (const token of this.tokens) {
      const tokenValue = token();
      if (tokenValue) {
        return tokenValue;
      }
    }

    return null;
  }

  addTokenSource(source: TokenSource) {
    if (this.existsTokenSource(source)) {
      return false;
    }

    this.tokens.push(source);
    return true;
  }

  prependTokenSource(source: TokenSource) {
    if (this.existsTokenSource(source)) {
      return false;
    }

    this.tokens.unshift(source);
    return true;
  }

  deleteTokenSource(source: TokenSource) {
    this.tokens = this.tokens.filter((token) => token !== source);
  }

  clearTokensSource(): void {
    this.tokens = [];
  }

  private existsTokenSource(source: TokenSource): boolean {
    return this.tokens.includes(source);
  }
}
